import { render } from "./ChartTypeCard.vue?vue&type=template&id=3f64d406"
import script from "./ChartTypeCard.vue?vue&type=script&lang=js"
export * from "./ChartTypeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__